import { render, staticRenderFns } from "./RGestion.vue?vue&type=template&id=a047497c&scoped=true&"
var script = {}
import style0 from "./RGestion.vue?vue&type=style&index=0&id=a047497c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a047497c",
  null
  
)

export default component.exports